import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton, TextField } from "@mui/material";
import { SmsContainer, generateInputs } from "./SmsInput";
import { useInputLogic } from "./useInputLogic";
import { CloseIcon } from "../Core/Icons/Close";
import axios from "axios";
import { useAppInfoWithReject } from "@/hooks/useAppInfoWithReject";
import { useDeviceContext } from "@/context/deviceContext/deviceContext";
import { CancelService } from "@/api/service/CancelService";
import { PenSVG } from "../docs/svg";

import { RetrySVG } from "./RetrySVG";
import { ApiService } from "@/api/service/ApiService";
import { sendEventToAmplitude } from "@/utils/sendEventToAmplitude";
import { useReject } from "@/hooks/useReject";
import { useSelector } from "react-redux";

export default function UDVOtp({
  open,
  setOpen,
  phone,
  goToPage,
  setOpenReject,
  timeOut,
}) {
  const { api } = ApiService();
  const { clientInfo, incomeVerification } = useSelector(
    (state: any) => state.user
  );
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { errorText, getAppInfo, appInfo, setDisconnect } =
    useAppInfoWithReject({
      setOpenRejectModal: setOpenReject,
    });

  const { isMobile } = useDeviceContext();

  const { otpInputs, inputChange, setOtpInputs } = useInputLogic(6);
  const { setErrorContent, setRejectOpen, setInfoKey } = useReject();

  React.useEffect(() => {
    (async () => {
      if (
        appInfo.processingEventStatus === "UNPROCESSED" &&
        appInfo.eventName === "VERIFICATION"
      ) {
        const { data } = await api.post(
          `/application/growing-business/verify-otp`,
          {
            message: {
              ru: "",
              kz: "",
            },
            password: otpInputs.join(""),
          }
        );
        if (data) {
          sendEventToAmplitude("online_credit_request_code", {
            tariff: "базовый",
            flow: incomeVerification
              ? "с подтверждением дохода"
              : "без подтверждения дохода",
          });
          goToPage();
          handleClose();
        }
      }
    })();
    if (
      appInfo.processInfo.stageName.ru === "ERROR" &&
      appInfo.eventName === "RETRY"
    ) {
      setErrorContent({ group: appInfo.processInfo.comments.ru, reason: "" });
      setRejectOpen(true);
    }
  }, [appInfo.eventName]);

  const validateCode = async (code: any) => {
    if (code.length === 6) {
      try {
        await getAppInfo();
      } catch (e) {
        throw e;
      }
    }
  };

  const [timer, setTimer] = React.useState(timeOut);
  const [timerStr, setTimerStr] = React.useState("");
  const [sendClick, setSendClick] = React.useState(false);

  React.useEffect(() => {
    let timeOut = setInterval(() => {
      if (timer !== 0 && !sendClick) {
        setTimer(timer - 1);
        let minutes = Math.floor(timer / 60);
        let seconds = timer - minutes * 60;
        setTimerStr(`${seconds}`);
      }
    }, 1000);
    return () => clearInterval(timeOut);
  }, [timer]);

  const { cancelAndRedirect } = CancelService();

  const retryOtp = async () => {
    setTimerStr("");
    setTimer(timeOut);

    const { data } = await api.post(
      `/application/growing-business/resend-otp`,
      {}
    );
    if (data) {
      setOtpInputs(generateInputs(6, "string"));
    }
  };

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={(theme) => ({
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: "768px",
          bgcolor: "background.paper",
          boxShadow: 24,
          padding: "32px",
          borderRadius: "32px",
          [theme.breakpoints.down("sm")]: {
            // width: "343px",
            padding: "16px",
            borderRadius: "16px",
            transform: "none",
            top: "auto",
            left: "0",
            right: "0",
            bottom: "0",
            borderEndStartRadius: "0",
            borderEndEndRadius: "0",
          },
        })}
      >
        <IconButton
          aria-label="delete"
          onClick={() => {
            setDisconnect(true);
            cancelAndRedirect();
            handleClose();
          }}
          sx={(theme) => ({
            position: "absolute",
            top: "32px",
            right: "32px",
            padding: "0",
            [theme.breakpoints.down("sm")]: {
              top: "16px",
              right: "16px",
            },
          })}
        >
          <CloseIcon />
        </IconButton>
        <Box
          sx={(theme) => ({
            backgroundColor: "#F3F3F7",
            padding: "8px 16px",
            display: "flex",
            justifyContent: "space-between",
            maxWidth: "632px",
            borderRadius: "8px",
            gap: "16px",
            marginBottom: "32px",
            [theme.breakpoints.down("sm")]: {
              marginTop: "40px",
              marginBottom: "16px",
            },
          })}
        >
          <Box>
            <PenSVG />
          </Box>
          <Typography
            sx={(theme) => ({
              color: "#676971",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              [theme.breakpoints.down("sm")]: {
                fontSize: "12px",
                lineHeight: "16px",
              },
            })}
          >
            Чтобы вам не потребовалось прикреплять скан вашего удостоверения
            личности, мы сделаем запрос в сервис «Цифровые документы». Дальше
            просто введите SMS-код от номера 1414
          </Typography>
        </Box>

        <Typography
          sx={(theme) => ({
            fontSize: "24px",
            fontWeight: "600",
            lineHeight: "32px",
            marginBottom: "8px",
            [theme.breakpoints.down("sm")]: {
              fontSize: "20px",
              lineHeight: "24px",
            },
          })}
        >
          Введите код из SMS отправленный с 1414
        </Typography>

        <Typography
          sx={(theme) => ({
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
            marginBottom: "24px",
            [theme.breakpoints.down("sm")]: {
              marginBottom: "24px",
            },
          })}
        >
          Отправили на номер {phone}
        </Typography>
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "0",
            },
          })}
        >
          <SmsContainer
            inputAmount={6}
            isValid={false}
            inputChange={inputChange}
            isUdv
          />

          {isMobile && (
            <>
              {timer > 0 ? (
                <Typography
                  sx={(theme) => ({
                    color: "#676971",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    marginTop: "16px",
                    [theme.breakpoints.down("sm")]: {
                      marginTop: "8px",
                    },
                  })}
                >
                  Прислать другой код через {timerStr} секунд
                </Typography>
              ) : (
                <Box
                  component="button"
                  onClick={retryOtp}
                  sx={(theme) => ({
                    display: "flex",
                    alignItems: "center",
                    marginTop: "16px",
                    backgroundColor: "#fff",
                    border: "none",
                    [theme.breakpoints.down("sm")]: {},
                  })}
                >
                  <RetrySVG />
                  <Typography
                    sx={(theme) => ({
                      color: "#27AE60",
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "24px",
                      marginLeft: "8px",
                      [theme.breakpoints.down("sm")]: {},
                    })}
                  >
                    Отправить код повторно
                  </Typography>
                </Box>
              )}
            </>
          )}

          <Button
            onClick={() => {
              validateCode(otpInputs.join(""));
            }}
            sx={(theme) => ({
              minWidth: "252px",
              padding: "15px 28px",
              maxHeight: "64px",
              borderRadius: "10px",
              backgroundColor: "#27AE60",
              color: "#FFF",
              fontSize: "18px",
              fontWeight: "500",
              lineHeight: "26px",
              ":hover": {
                background: "#27AE60",
                color: "#FFF",
              },
              [theme.breakpoints.down("sm")]: {
                margin: "24px 0 0",
                width: "100%",
              },
            })}
          >
            Продолжить
          </Button>
        </Box>
        {!isMobile && (
          <>
            {timer > 0 ? (
              <Typography
                sx={(theme) => ({
                  color: "#676971",
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  marginTop: "16px",
                  [theme.breakpoints.down("sm")]: {
                    marginTop: "8px",
                  },
                })}
              >
                Прислать другой код через {timerStr} секунд
              </Typography>
            ) : (
              <Box
                component="button"
                onClick={retryOtp}
                sx={(theme) => ({
                  display: "flex",
                  alignItems: "center",
                  marginTop: "16px",
                  backgroundColor: "#fff",
                  border: "none",
                  [theme.breakpoints.down("sm")]: {},
                })}
              >
                <RetrySVG />
                <Typography
                  sx={(theme) => ({
                    color: "#27AE60",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "24px",
                    marginLeft: "8px",
                    [theme.breakpoints.down("sm")]: {},
                  })}
                >
                  Отправить код повторно
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>
    </Modal>
  );
}
